// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialSection_container__31H0b","icon":"SocialSection_icon__q03lB","link":"SocialSection_link__1lBV8","divider":"SocialSection_divider__1y7v4"};